import { ref, watch, computed } from '@vue/composition-api'
import { useToast } from "vue-toastification/composition";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import i18n from "@/libs/i18n";
import store from "@/store";

export default function studentListQuery() {
    const toast = useToast()
    const studentTable = ref(null)
    const perPage = ref(10)
    const totalStudents = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)

    const statusFilter = ref(1)
    const groupFilter = ref(null)
    const groupOptions = ref([])

    const tableColumns = ref([
        { key: 'name', label: i18n.t('Student'), sortable: true },
        { key: 'contact_data', label: i18n.t('Contact data'), sortable: true },
        { key: groupOptions.value.length > 1 ?  'groups' : '', label: i18n.t('Groups') },
        { key: 'status', label: i18n.t('Status')},
        { key: 'actions', label: i18n.t('Actions')},
    ])

    const dataMeta = computed(() => {
        const localItemsCount = studentTable.value ? studentTable.value.localItems.length: 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalStudents.value,
        }
    });

    const refetchData = function() {
        studentTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery, groupFilter, statusFilter], () => {
        refetchData()
    })

    const fetchStudents = function(ctx, callback) {
        store.dispatch('students/fetchStudents', {
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
            group: groupFilter.value,
            status: statusFilter.value
        })
        .then(response => {
            const { students, groups, total } = response.data
            callback(students)
            groupOptions.value = groups
            tableColumns.value = [
                { key: 'name', label: i18n.t('Student'), sortable: true },
                { key: 'contact_data', label: i18n.t('Contact data'), sortable: true },
                { key: groupOptions.value.length > 1 ?  'groups' : '', label: i18n.t('Groups') },
                { key: 'status', label: i18n.t('Status')},
                { key: 'actions', label: i18n.t('Actions')},
            ]
            totalStudents.value = total
        })
        .catch(error => {
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching students list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
    }

    const resolveStudentStatusVariant = function(status) {
        if (status === 1) return 'success'
        if (status === 0) return 'secondary'
        if (status === -1) return 'warning'

        return 'primary'
    }

    return {
        fetchStudents,
        tableColumns,
        perPage,
        currentPage,
        totalStudents,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        studentTable,
        refetchData,
        resolveStudentStatusVariant,
        groupFilter,
        statusFilter,
        groupOptions
    }
}
